const TEXTS = {
  login: {
    en: "Login",
    "el-GR": "Σύνδεση",
  },
  homepage: {
    en: "Homepage",
    "el-GR": "Αρχική",
  },
  logout: {
    en: "Logout",
    "el-GR": "Αποσύνδεση",
  },
  register: {
    en: "Register",
    "el-GR": "Εγγραφή",
  },
  upload: {
    en: "Upload",
    "el-GR": "Ανεβάστε αρχείο",
  },
  download: {
    en: "Download",
    "el-GR": "Λήψη αρχείου",
  },
  success: {
    en: "Login successful",
    "el-GR": "Επιτυχής Σύνδεση",
  },
  error: {
    en: "Something went wrong! Please try again.",
    "el-GR": "Κάτι πήγε στραβά! Παρακαλώ προσπαθήστε ξανά.",
  },
  name: {
    en: "Name",
    "el-GR": "Όνομα",
  },
  lastname: {
    en: "Last Name",
    "el-GR": "Επώνυμο",
  },
  phone: {
    en: "Phone",
    "el-GR": "Τηλέφωνο",
  },
  password: {
    en: "Password",
    "el-GR": "Κωδικός πρόσβασης",
  },
  "confirm-password": {
    en: "Confirm Password",
    "el-GR": "Επιβεβαίωση κωδικού πρόσβασης",
  },
  "login-register": {
    en: "Login / Register",
    "el-GR": "Σύνδεση / Εγγραφή",
  },
  desc: {
    en: "Newest to oldest",
    "el-GR": "Νεότερο προς παλαιότερο",
  },
  asc: {
    en: "Oldest to newest",
    "el-GR": "Παλαιότερο προς νεότερο",
  },
  "upload-success": {
    en: "File uploaded successfully!",
    "el-GR": "Το αρχείο ανέβηκε επιτυχώς!",
  },
  "upload-error": {
    en: "File upload failed.",
    "el-GR": "Η μεταφόρτωση του αρχείου απέτυχε.",
  },
  // Contact form
  "your-name": {
    en: "Your name",
    "el-GR": "Το όνομά σας",
  },
  "your-email": {
    en: "Your email",
    "el-GR": "Το email σας",
  },
  subject: {
    en: "Subject",
    "el-GR": "Θέμα",
  },
  message: {
    en: "Message",
    "el-GR": "Το μήνυμά σας",
  },
  submit: {
    en: "Submit",
    "el-GR": "Αποστολή",
  },
};

const translations = (string, currentLanguage = "el-GR") => {
  const text = TEXTS?.[string];
  if (text) {
    return text[currentLanguage] || string;
  } else {
    return string;
  }
};

export default translations;
